import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import CssBaseline from '@mui/material/CssBaseline';
import AppTheme from './components/customizations/AppTheme';
import { AuthProvider } from './authentication/AuthContext';
import { UploadProvider } from './contexts/UploadContext';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <AppTheme>
      <CssBaseline enableColorScheme />
      <BrowserRouter>
        <AuthProvider>
          <UploadProvider>
            <App />
          </UploadProvider>
        </AuthProvider>
      </BrowserRouter>
    </AppTheme>
  </React.StrictMode>
);